<template>
  <b-col md="6" lg="4" class="create-new-item">
    <b-card
      no-body
      class="h-100 d-flex flex-row justify-content-center align-items-center"
      role="button"
      v-on="$listeners"
    >
      <feather-icon icon="PlusIcon" size="24" />
      <h4 class="mb-0 ml-1 text-capitalize">
        {{ $t('communications.createNew') }}
      </h4>
    </b-card>
  </b-col>
</template>

<script>
import { BCard, BCol } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCol,
  },
}
</script>

<style lang="scss" scoped>
.create-new-item {
  min-height: 500px !important;
  height: 500px !important;
  max-height: 500px !important;
  margin-bottom: 2rem;
}
</style>
